const Yup = require("yup");

const patientDisease = Yup.object().shape({
  description: Yup.string().required("Description is required"),
  since: Yup.date().required("Since date is required"),
  type: Yup.number().required("Type is required"),
});

export default patientDisease;
